function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Drag");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Move-dota",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.3
}, React.createElement("g", {
  id: "Group-2-Copy",
  fill: "#000000",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M2.78571429,1.46428571 C2.78571429,2.23357019 2.1621416,2.85714286 1.39285716,2.85714286 C0.62357266,2.85714286 0,2.23357019 0,1.46428571 C0,0.695116601 0.62357266,0.0714285714 1.39285716,0.0714285714 C2.1621416,0.0714285714 2.78571429,0.695116601 2.78571429,1.46428571 L2.78571429,1.46428571 Z",
  id: "Path",
  transform: "translate(1.392857, 1.464286) rotate(-90.000000) translate(-1.392857, -1.464286) "
}), React.createElement("path", {
  d: "M2.78571429,6.80357143 C2.78571429,7.5728559 2.16214163,8.19642857 1.39285716,8.19642857 C0.623688052,8.19642857 -6.82109131e-13,7.5728559 -6.82109131e-13,6.80357143 C-6.82109131e-13,6.03440231 0.623688052,5.41071429 1.39285716,5.41071429 C2.16214163,5.41071429 2.78571429,6.03440231 2.78571429,6.80357143 Z",
  id: "Path",
  transform: "translate(1.392857, 6.803571) rotate(-90.000000) translate(-1.392857, -6.803571) "
}), React.createElement("path", {
  d: "M2.78571429,12.1428571 C2.78571429,12.9121416 2.16214162,13.5357143 1.39285714,13.5357143 C0.623572667,13.5357143 -6.82109131e-13,12.9121416 -6.82109131e-13,12.1428571 C-6.82109131e-13,11.373688 0.623572667,10.75 1.39285714,10.75 C2.16214162,10.75 2.78571429,11.373688 2.78571429,12.1428571 Z",
  id: "Path",
  transform: "translate(1.392857, 12.142857) rotate(-90.000000) translate(-1.392857, -12.142857) "
}), React.createElement("path", {
  d: "M8.73214286,1.46428571 C8.73214286,2.23357019 8.10857017,2.85714286 7.33928573,2.85714286 C6.57000123,2.85714286 5.94642857,2.23357019 5.94642857,1.46428571 C5.94642857,0.695116601 6.57000123,0.0714285714 7.33928573,0.0714285714 C8.10857017,0.0714285714 8.73214286,0.695116601 8.73214286,1.46428571 L8.73214286,1.46428571 Z",
  id: "Path",
  transform: "translate(7.339286, 1.464286) rotate(-90.000000) translate(-7.339286, -1.464286) "
}), React.createElement("path", {
  d: "M8.73214286,6.80357143 C8.73214286,7.5728559 8.1085702,8.19642857 7.33928573,8.19642857 C6.57011662,8.19642857 5.94642857,7.5728559 5.94642857,6.80357143 C5.94642857,6.03440231 6.57011662,5.41071429 7.33928573,5.41071429 C8.1085702,5.41071429 8.73214286,6.03440231 8.73214286,6.80357143 Z",
  id: "Path",
  transform: "translate(7.339286, 6.803571) rotate(-90.000000) translate(-7.339286, -6.803571) "
}), React.createElement("path", {
  d: "M8.73214286,12.1428571 C8.73214286,12.9121416 8.10857019,13.5357143 7.33928571,13.5357143 C6.57000124,13.5357143 5.94642857,12.9121416 5.94642857,12.1428571 C5.94642857,11.373688 6.57000124,10.75 7.33928571,10.75 C8.10857019,10.75 8.73214286,11.373688 8.73214286,12.1428571 Z",
  id: "Path",
  transform: "translate(7.339286, 12.142857) rotate(-90.000000) translate(-7.339286, -12.142857) "
})));

var SvgDrag = function SvgDrag(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "9px",
    height: "14px",
    viewBox: "0 0 9 14",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDrag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/drag.0cf1f029.svg";
export { ForwardRef as ReactComponent };